// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/apps/engagement_reports/engagement_reports_data" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsEngagementReportsEngagementReportsData } from "./constants";
import type {
  AppsEngagementReportsEngagementReportsDataParams,
  AppsEngagementReportsEngagementReportsDataResult,
} from "./types";

export const getDataTableAppsEngagementReportsEngagementReportsData = reactQueryTableFetcherAdapter(
  appsEngagementReportsEngagementReportsData,
  async (
    signal,
    {
      appGroupId,
      query,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
      ...rest
    }: AppsEngagementReportsEngagementReportsDataParams
  ): Promise<AppsEngagementReportsEngagementReportsDataResult> => {
    return fetch(
      "/apps/engagement_reports/engagement_reports_data",
      "GET",
      {
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
        ...rest,
      },
      { signal }
    );
  }
);
